/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

var _excluded = ["children", "className", "short"];
var CardBody = function CardBody(_ref) {
  var children = _ref.children,
    className = _ref.className,
    _short = _ref["short"],
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    className: classnames({
      'cpc--card__body': true,
      'cpc--card__body--short': _short
    }, className)
  }), children);
};
CardBody.propTypes = {
  /**
   * A className that will be applied to the CardBody component.
   */
  className: PropTypes.string,
  /**
   * A CardIllustration component that will display an svg image.
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  /**
   * Whether or not to apply the compact body text styles. This should be applied if the card contains 4 lines of text or less.
   */
  "short": PropTypes.bool
};
var CardBody$1 = CardBody;

export { CardBody$1 as default };
